<template>
  <div class="chapter publick">
    <div class="chapterLeft fl">
      <ul v-for="(item, index) in chapter" :key="index">
        <div class="tit">
          {{item.name}}
          <span v-if=" item.is_apply === 1 " @click="shengqingjiesuo(item.id)" class="shengqingjiesuo">申请解锁</span>
        </div>
        <li v-for="(items, indexs) in item.lesson" :key="indexs">
          <div class="t fl">{{index+1}} - {{indexs+1}}&nbsp;&nbsp;&nbsp;&nbsp;{{items.name}} <span>{{items.lesson_completion}}</span>
          </div>
          <div
            @click="student(item.id,items.id,items.relate_type,items.px_course_id,items.px_chapters_id,items.is_study,items.overdue,items.not_in_msg)"
            class="student fr">
            立即学习
          </div>
        </li>
      </ul>
    </div>
    <div class="detRight fr">
      <detRight :pushcourse="pushcourse" :lecturer="lecturer"></detRight>
    </div>

    <div v-if="subjectFalse" class="subjectLayer">
      <subject></subject>
    </div>
  </div>
</template>

<script>
  import detRight from '@/components/CourseDetails/detRight/detRight'
  import subject from '@/components/videoLayer/subject/subject'

  export default {
    components: {
      detRight,
      subject
    },
    data () {
      return {
        lecturer: [],
        chapter: [],
        pushcourse: [],
        subjectFalse: false
      }
    },
    created () {
      this.$nextTick(function () {
        this.getData()
      })
    },
    methods: {
      shengqingjiesuo (id) {

        this.$confirm('确定解锁章节?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('/apipx/Teacher/adddeblock', {
            px_chapters_id: id,
            token: JSON.parse(localStorage.getItem('login')).token
          }).then(res => {
            if (res.code === 0) {
              this.getData()
            }
          })
        })
      },
      getData () {
        this.$http.post('/apipx/Course/info', {
          px_course_id: this.$parent.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
            this.$nextTick(function () {
              this.lecturer = this.$parent.info.lecturer
              this.chapter = this.$parent.info.chapter
              this.pushcourse = this.$parent.pushcourse
            })
          }
        })
      },
      student (coursed, id, type, pxcourseid, pxchaptersid, isStudy, overdue, not_in_msg) {
        if (this.$parent.info.is_buy === 2) { // 未购买
          this.$message({
            message: not_in_msg,
            type: 'error',
            duration: 2000
          })
          return false
        }

        if (overdue === 2) { // 1可以学  2不行
          this.$message({
            message: not_in_msg,
            type: 'error',
            duration: 2000
          })
          return false
        }

        if (type === 'live') {
          this.$router.push({
            path: '/videoLayer',
            query: {
              course_id: this.$parent.info.id,
              id: id,
              px_course_id: pxcourseid,
              px_chapters_id: pxchaptersid
            }
          })
        } else {
          if (this.$parent.info.is_order === 1) { // 按照顺序学习 1 是  2 不是
            if (isStudy === 1) { // 学习完成  可否点击  2 不是 1 是
              this.$router.push({
                path: '/videoLayer',
                query: {
                  course_id: this.$parent.info.id,
                  id: id,
                  px_course_id: pxcourseid,
                  px_chapters_id: pxchaptersid
                }
              })
            } else {
              this.$message({
                duration: '2000',
                type: 'error',
                message: not_in_msg
              })
            }
          } else {
            this.$router.push({
              path: '/videoLayer',
              query: {
                course_id: this.$parent.info.id,
                id: id,
                px_course_id: pxcourseid,
                px_chapters_id: pxchaptersid
              }
            })
          }
        }
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .chapter {
    color: #535353;
    margin-bottom: 100px !important;
    overflow: hidden;
    width: 1200px !important;

    .subjectLayer {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99;
    }

    .shengqingjiesuo {
      font-size: 14px;
      margin: 0 0 0 20px;
      cursor: pointer;
    }

    .chapterLeft {
      width: 760px;
      margin-top: 20px;

      ul {
        overflow: hidden;
        border-radius: 20px;
        background-color: #fff;
        box-shadow: 0px 0px 35px #f8f8f8;
        margin-top: 20px;

        .tit {
          padding: 0 35px;
          margin: 30px auto 10px;
          font-size: 24px;
        }

        li {
          height: 60px;
          line-height: 60px;
          padding: 0 35px;
          overflow: hidden;

          .t {
            span {
              font-size: 12px;
              margin: 0 0 0 10px;
            }
          }

          .student {
            display: none;
            width: 80px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background-color: #ff8484;
            text-align: center;
            border-radius: 10px;
            margin: 10px 0 0 0;
            cursor: pointer;

            &:hover {
              background-color: #ffa8a8;
            }
          }

          &:hover {
            background-color: #fff8f8;
            color: #ff8484;

            .student {
              display: block;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/chapter/chapter.vue